export default "__VITE_ASSET__BbG42jXr__"